@if(isB2b){
<div class="">
  <div class="top-bar-categories flex align-items-center">
    <div class="flex align-items-center m-1">
      <i class="fas fa-history me-3"></i>
      <h5 class="m-0">Documentos</h5>
    </div>
  </div>
  <div class="p-1">
    <p-table
      [first]="first"
      [value]="orders"
      [paginator]="true"
      (onLazyLoad)="fetchOrders($event)"
      [rows]="rows"
      [loading]="loading"
      [lazy]="true"
      [totalRecords]="totalRows"
      currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} registros"
      [rowsPerPageOptions]="[10, 25, 50]"
      styleClass="p-datatable-striped p-datatable-sm"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center">OV</th>
          <th class="text-center">OC</th>
          <th class="text-center">CC</th>
          <th class="text-center">DTE</th>
          <th class="text-center">FECHA</th>
          <th class="text-center">ESTADO</th>
          <th class="text-center">ORIGEN</th>
          <th class="text-center">TOTAL</th>
        </tr>
        <!-- <tr>
            <th>
              <p-columnFilter
                type="text"
                class="w-full"
                field="ov"
                placeholder="Buscar por OV"
                [showMenu]="false"
                [showClearButton]="false"
              ></p-columnFilter>
            </th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <p-columnFilter
                type="text"
                class="w-full"
                field="status"
                placeholder="Buscar por estado"
                [showMenu]="false"
                [showClearButton]="false"
              ></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                class="w-full"
                field="origin"
                placeholder="Buscar por origen"
                [showMenu]="false"
                [showClearButton]="false"
              ></p-columnFilter>
            </th>
            <th></th>
          </tr> -->
      </ng-template>
      <ng-template pTemplate="body" let-order>
        <tr>
          <td class="text-center">
            <!-- {{ order.salesId }} -->
            <a
              routerLink="/carro-compra/downloadpdf"
              [queryParams]="{ numero: order.salesId }"
              target="_blank"
              >{{ order.salesId }}</a
            >
          </td>
          <td class="text-center">
            <ng-container *ngIf="order?.idShoppingCart">
              <a
                target="_blank"
                class="dropdown-item"
                routerLink="/carro-compra/downloadpdf"
                [queryParams]="{
                  numero: order?.idShoppingCart,
                  tipo: 'orden-compra'
                }"
              >
                Ver OC
              </a>
            </ng-container>
            <!-- <ng-container *ngIf="order.ocs && order.ocs.length > 0">
                <ng-container *ngFor="let oc of order?.ocs">
                  <a> {{ oc.referencia.slice(0, 15) }} </a><br />
                </ng-container>
              </ng-container> -->
          </td>
          <td class="text-center">
            <ng-container *ngIf="order?.costCenter">
              {{ order?.costCenter }}
            </ng-container>
            <ng-container *ngIf="!order?.costCenter"> </ng-container>
            <ng-container *ngIf="order?.costCenter === ''">
              <font color="red"> S/CC</font>
            </ng-container>
          </td>
          <td class="text-center">
            <ng-container *ngIf="order.invoice">
              <a
                routerLink="/carro-compra/downloadpdf"
                [queryParams]="{
                  numero: order.invoice.number,
                  tipo: 'factura',
                  tipo_doc: order.observation
                }"
                target="_blank"
                >{{ order.invoice.number }}</a
              >
            </ng-container>
            <ng-container *ngIf="!order.invoice"> NN </ng-container>
          </td>
          <td class="text-center">
            {{ order.timestamps.creationDate | date : 'dd-MM-yy' }}
          </td>
          <td class="text-center">
            {{ order.status.statusName }}
          </td>
          <td class="text-center">
            {{ order.salesOrigin.name }}
          </td>
          <td class="text-center">{{ order.payment.amount | currency }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
} @else {
<div class="  ">
  <div
    class="top-bar-categories flex align-items-center mb-3"
    [class.p-0]="innerWidth < 450"
    [class.ps-4]="innerWidth < 450"
    (window:resize)="onResize($event)"
  >
    <div class="title flex align-items-center me-auto">
      <i _ngcontent-serverapp-c11="" class="fas fa-history me-3"></i>
      <h5>Documentos</h5>
    </div>
  </div>
  <div class="row m-0">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body table-responsive">
          <div
            class="col-sm-12"
            style="
              margin-bottom: 20px;
              padding: 10px;
              border: 1px solid #33333338;
            "
          >
            <table
              datatable
              [dtOptions]="dtOptions"
              class="row-border"
              width="100%"
            >
              <thead class="table-dark">
                <tr>
                  <th>OV</th>
                  <th>OC</th>
                  <th>Centro Costo</th>
                  <th>Documento</th>
                  <th>Fecha</th>
                  <th>Sucursal</th>
                  <th>Vendedor</th>
                  <th>Neto</th>
                  <th>{{ taxConfig.name }}</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody *ngIf="b2c_rows.length && !loadingData">
                <tr *ngFor="let order of b2c_rows">
                  <td align="center">
                    <a
                      routerLink="/carro-compra/downloadpdf"
                      [queryParams]="{ numero: order.salesId }"
                      target="_blank"
                      >{{ order.salesId }}</a
                    >
                  </td>
                  <!-- <td align="center"><a href="https://b2b-api.implementos.cl/api/carro/getoc?id={{ order._id }}" target="_blank">{{ order.ordenCompra }}</a></td> -->
                  <td align="center" nowrap>
                    {{ order.purchaseOrder || '0' }}
                  </td>
                  <td align="center" nowrap>
                    <ng-container
                      *ngIf="
                        order.purchaseOrder != 0 && order.purchaseOrder != null
                      "
                    >
                      <ng-container
                        *ngIf="
                          order.carros != null && order.carros.purchaseOrder
                        "
                      >
                        {{ order.purchaseOrder }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          order.purchaseOrder == null || !order.purchaseOrder
                        "
                      >
                        <font color="red">{{ 'S/CC' }}</font>
                      </ng-container>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        order.purchaseOrder == null || order.purchaseOrder == 0
                      "
                    >
                      <font color="red"> S/CC</font>
                    </ng-container>
                  </td>
                  <td align="center">
                    <a
                      routerLink="/carro-compra/downloadpdf"
                      [queryParams]="{
                        numero: order.invoiceNumber,
                        tipo: 'factura',
                        tipo_doc: order.observation
                      }"
                      target="_blank"
                      >{{ order.invoiceNumber }}</a
                    >
                  </td>
                  <td align="center">
                    {{ order.invoiceDate | date : 'dd-MM-yy hh:mm' }}
                  </td>
                  <td align="center">{{ order.branch }}</td>
                  <td>{{ order.seller ? order.seller.name : '' }}</td>
                  <td align="right">${{ order.lineAmount }}</td>
                  <td align="right">${{ order.ivaAmount }}</td>
                  <td align="right">${{ order.total }}</td>
                </tr>
              </tbody>
              <tbody *ngIf="b2c_rows?.length == 0 && !loadingData">
                <tr>
                  <td colspan="10" class="no-data-available">
                    <div
                      class="col-sm-12"
                      style="
                        margin-bottom: 20px;
                        padding: 10px;
                        border: 1px solid #33333338;
                      "
                    >
                      <i
                        class="fas fa-info-circle"
                        style="margin-right: 10px"
                      ></i>
                      No hay pedidos con este filtro
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="loadingData">
                <tr>
                  <td align="center" colspan="10" class="no-data-available">
                    <div
                      class="col-sm-12"
                      style="
                        margin-bottom: 20px;
                        padding: 10px;
                        border: 1px solid #33333338;
                      "
                    >
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
